function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("clipPath", {
  id: "_clip1"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 26.5,
  height: 26.5
}));

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 27 27",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard1",
    x: 0,
    y: 0,
    width: 26.5,
    height: 26.5,
    style: {
      fill: "none"
    }
  }), _ref2, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M4.467,26.503c-2.367,0.081 -4.382,-1.798 -4.467,-4.164l0,-18.171c0.084,-2.368 2.1,-4.247 4.467,-4.165l13.326,-0c0.623,-0 1.136,0.512 1.136,1.136c-0,0.623 -0.513,1.136 -1.136,1.136l-13.326,-0c-1.121,-0.079 -2.11,0.773 -2.2,1.893l0,18.171c0.09,1.119 1.079,1.97 2.2,1.893l13.326,-0c0.623,-0 1.135,0.512 1.135,1.135c0,0.623 -0.512,1.136 -1.135,1.136l-13.326,-0Zm14.033,-6.39c-0.44,-0.442 -0.44,-1.166 -0,-1.607l4.118,-4.117l-13.911,-0c-0.623,-0 -1.136,-0.513 -1.136,-1.136c-0,-0.624 0.513,-1.136 1.136,-1.136l13.916,-0l-4.123,-4.114c-0.213,-0.214 -0.333,-0.504 -0.333,-0.805c-0,-0.625 0.513,-1.139 1.138,-1.139c0.302,0 0.592,0.12 0.805,0.334l6.057,6.057c0.213,0.212 0.333,0.501 0.333,0.802c-0,0.301 -0.12,0.59 -0.333,0.803l-6.057,6.058c-0.441,0.439 -1.166,0.439 -1.607,-0l-0.003,-0Z",
    style: {
      fill: "#d1d1d1",
      fillRule: "nonzero"
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.1dabf066.svg";
export { ForwardRef as ReactComponent };